import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { DistributorsService, ProfileService } from 'core/services';
import { PlansService } from 'core/services/plans.service';

export const DistributorResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  distributorsService: DistributorsService = inject(DistributorsService),
  plansService: PlansService = inject(PlansService),
  profileService: ProfileService = inject(ProfileService)
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const distributorId =
      profileService.getFixedPartnerId() ||
      route.paramMap.get('distributorId') ||
      route.queryParamMap.get('distributorId');
    if (distributorId) {
      distributorsService.getDistributor(distributorId).subscribe({
        next: (remoteDistributor) => {
          plansService.getClientPlan(remoteDistributor.clientId).then((plan) => {
            remoteDistributor.plan = plan;
            resolve(remoteDistributor);
          });
        },
        error: (err) => reject(err)
      });
    } else {
      resolve(null);
    }
  });
};
